import {groupBy} from "lodash/collection";

const findByThreadName = (state) => {
  return state.feeds.filter(item =>
    item.threadname.toLowerCase().includes(state.searchParams.input.toLowerCase())
      &&
    state.status.current.includes(item.status)
  );
};

const findByUserName = (state) => {
  return state.feeds.filter(
    item => item.username.toLowerCase().includes(state.searchParams.input.toLowerCase())
      &&
    state.status.current.includes(item.status)
  );
};

const findByNumber = (state) => {
  return state.feeds.filter(item =>
    item.id === state.searchParams.input
      &&
    state.status.current.includes(item.status)
  );
};

export default {
  operator: {
    byName: (state) => {
      return findByThreadName(state);
    },

    byUser: (state) => {
      return findByUserName(state);
    },

    byNumber: (state) => {
      return findByNumber(state);
    },
  },
  manager: {
    byName: (state) => {
      const data = findByThreadName(state);
      return data;
    },

    byUser: (state) => {
      const data = findByUserName(state);
      return data;
    },

    byNumber: (state) => {
      const data = findByNumber(state);
      return data;
    },
  },
  admin: {
    byName: (state) => {
      const data = findByThreadName(state);
      return data;
    },

    byUser: (state) => {
      const data = findByUserName(state);
      return data;
    },

    byNumber: (state) => {
      const data = findByNumber(state);
      return data;
    },
  }
};

